export default __webpack_public_path__ + "static/Snooze_hero_background-Optimised-v3-49b95f50378d45d00b2ae02c49c0c863.png";